/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { NotificationType } from "@/store/enum/notificationType.enum";
import { NotificationModule } from "@/store/modules/notification.store";
import { UserModule } from "@/store/modules/user.store";
import Vue from "vue";

/**
 * Factory to create notifications
 */
export class NotificationFactory {
  static createTaxIdMissingNotification() {
    NotificationModule.addNotification({
      type: NotificationType.WARNING,
      actionText: "components.thg.ThgOverview.notifications.btnText",
      dismissText: "components.thg.ThgOverview.notifications.dismissText",
      message: "components.thg.ThgOverview.notifications.taxNumberMissing",
      isVisible: true,
      location: { name: "Profile" }
    });
  }

  static createAddressMissingNotification() {
    NotificationModule.addNotification({
      type: NotificationType.WARNING,
      actionText: "components.thg.ThgOverview.notifications.btnText",
      dismissText: "components.thg.ThgOverview.notifications.dismissText",
      message: "components.thg.ThgOverview.notifications.addressMissing",
      isVisible: true,
      location: { name: "Profile" }
    });
  }

  static createIbanMissingNotification() {
    NotificationModule.addNotification({
      type: NotificationType.WARNING,
      actionText: "components.thg.ThgOverview.notifications.btnText",
      dismissText: "components.thg.ThgOverview.notifications.dismissText",
      message: "components.thg.ThgOverview.notifications.bankingMissing",
      isVisible: true,
      location: { name: "Profile" }
    });
  }

  static createNewGhghQuotaNotification() {
    NotificationModule.addNotification({
      type: NotificationType.SUCCESS,
      actionText: "components.thg.ThgOverview.notifications.ghgQuotaBtnText",
      dismissText: "components.thg.ThgOverview.notifications.dismissText",
      message: "components.thg.ThgOverview.notifications.ghgQuota",
      isVisible: true,
      location: { name: "ThgVehicleOverview" },
      action: async () => {
        Vue.$log.info("User clicked on GHG Notification.");
      }
    });
  }

  static createMarketingOptinMissingNotification() {
    NotificationModule.addNotification({
      type: NotificationType.INFO,
      actionText: "components.thg.ThgOverview.notifications.updateMarketingOptIn",
      dismissText: "components.thg.ThgOverview.notifications.updateMarketingOptInDismiss",
      message: "components.thg.ThgOverview.notifications.isMarketingOptinMissing",
      isVisible: true,
      action: async () => {
        await UserModule.setIsMarketingOptin();
      }
    });
  }
}
